module.exports = __webpack_public_path__ + "static/media/yary-novo.8e74d6e4.jpeg";